
import React from 'react';
import { connect } from 'react-redux';
import { getTennisCompetitions } from '../../../../selectors/common';
import { tennisFeedSettings } from '../../../../selectors/feedSettings';

import FeedSettings from '..';
import { PERMISSIONS } from '../../../../constants';
import { aGetTennisFeedSettingsRequest, aUpdateTennisFeedStatus, aUpdateTennisOddsStatus } from '../../../../reducers';
import { aClearTennisFeedSettings } from '../../../../reducers/feedSettings';

const mapToProps = (state) => ({
  leagues: getTennisCompetitions(state),
  feedSettings: tennisFeedSettings(state),
});

const actionsToProps = (dispatch) => ({
  getFeedSettings: (payload) => dispatch(aGetTennisFeedSettingsRequest(payload)),
  updateFeedStatus: (payload) => dispatch(aUpdateTennisFeedStatus(payload)),
  updateOddsStatus: (payload) => dispatch(aUpdateTennisOddsStatus(payload)),
  clearFeedSettings: (payload) => dispatch(aClearTennisFeedSettings(payload)),
});

const TennisFeedSettings = (props) => (

  <FeedSettings
    leagues={props.leagues}
    feedSettings={props.feedSettings}
    getFeedSettings={props.getFeedSettings}
    updateFeedStatus={props.updateFeedStatus}
    updateOddsStatus={props.updateOddsStatus}
    clearFeedSettings={props.clearFeedSettings}
    permissionToUpdate={PERMISSIONS.TENNIS_FEED_SETTINGS_UPDATE}
    permissionToInvalidateOdds={PERMISSIONS.TENNIS_FEED_SETTINGS_INVALIDATE_ODDS}
  />

);

export default connect(mapToProps, actionsToProps)(TennisFeedSettings);

